import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import baseUrl from '../../lib/baseUrl';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import Utility from "../../Consts/Utility";
import {ApiRequest} from "../../Consts/ApiRequest";
import Rule from "../../Consts/Rules";
import * as React from "react";

type LoginInputs = {
  userId: string;
  password: string;
  authority: number;
  access_token: string;
};

interface token {
  idToken: string;
}

const LoginForm = (props: any) => {
  const { register, handleSubmit, formState: { errors } } = useForm<LoginInputs>();
  const [userId, setUserId] = useState<string>("");
  const [siteRecno, setSiteRecno] = useState<string>("");

  const [password, setPassword] = useState<string>("");
  const [authority, setAuthority] = useState<number>();
  const [access_token, setAccessToken] = useState<string>();
  const [error, setError] = useState<string[]>([]);

  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([
      'authority',
      'access_token',
      "siteId",
      "siteRecno"
  ]);

    const idRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        // ブラウザが入力フィールドを自動入力した場合、Reactの状態を更新
        const idValue = idRef.current?.value;
        if (idValue) setUserId(idValue);
        const passwordValue = passwordRef.current?.value;
        if (passwordValue) setPassword(passwordValue);
    }, []);

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    useEffect(() => {
    if (cookies.authority !== null) {
      Utility.redirectByAuthority(navigate, cookies.authority, cookies.siteId, cookies.siteRecno);
    }

  }, [authority, access_token]);

  const onSubmit: SubmitHandler<LoginInputs> = async (data) => {
    try {
        const token = cookies.access_token || "";
        let params = {
            userId: userId,
            password: password,
        };
        await ApiRequest.postLogin(params, token, (response: any) => {
            setAuthority(response.data.authority);
            setAccessToken(response.data.access_token);
            setError(response.data.messsages);

            var authority = response.data.authority;
            var access_token = response.data.access_token;
            var site_id = response.data.siteId;
            var site_recno = response.data.siteRecno;
            setSiteRecno(site_recno);
            setCookie('access_token', access_token, { path: '/', maxAge: 60 * 60 * 24 * 180 });
            setCookie('authority', authority, { path: '/', maxAge: 60 * 60 * 24 * 180 });
            setCookie('siteId', site_id, { path: '/', maxAge: 60 * 60 * 24 * 180 });
            setCookie('siteRecno', site_recno, { path: '/', maxAge: 60 * 60 * 24 * 180 });

            if (authority !== null) {
                Utility.redirectByAuthority(navigate, authority, site_id, site_recno);
            }
        }, (error: any) => {
            errorCallback(error);
        });
    } catch (error) {
      console.error("Error fetching authority:", error);
    }
  };

  return (
    <>
      <section className="login-block">
        <div className="login-box">
          <div className="login-header">
            <div className="login-title">
              ログイン
            </div>
          </div>
          <div className="login-body">

            {/* APIバリデーション */}
            {
              error.length >0 ?
                <ul className="error-box">
                    {error.map((item, index) => (
                        <li>{item}</li>
                    ))}
                </ul>
                : null
            }

            {/* フロントバリデーション */}
            {(errors.password || errors.userId) && (
              <ul className="error-box">
                <li>ログインできません。ログインIDとパスワードをお確かめください。</li>
              </ul>
            )}

            <div className="login-box-elm">
              <div className="login-box-elm-name">ログインID</div>
              <div className="login-box-elm-input">
                <input
                  type="text"
                  ref={idRef}
                  value={userId}
                  placeholder="userId"
                  className={"col-320 " + (errors.userId ? "error-disp" : "")}
                  onChange={e => setUserId(e.target.value)}
                />
              </div>
            </div>
            <div className="login-box-elm">
              <div className="login-box-elm-name">パスワード</div>
              <div className="login-box-elm-input">
                <input
                  type="password"
                  ref={passwordRef}
                  value={password}
                  placeholder="password"
                  className={"col-320 " + (errors.userId ? "error-disp" : "")}
                  onChange={e => setPassword(e.target.value)}
                />

              </div>
            </div>
          </div>
          <div className="login-footer">
            <div className="login-action">
              <form onSubmit={handleSubmit(onSubmit)}>
                <button type="submit" className="btn btn-blue">
                  <i className="icon-login-w"></i>ログイン
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="login-message">
          <p>
            <b>※データの取扱いについて</b><br />
            ・取得されたデータの管理はお客様の責任でお願い致します。<br />
            ・レンタル終了時にデータは削除されますので、ご返却までにデータダウンロードをお願いします。<br />
            以降データ閲覧、データ受け渡しなどのご要望には対応致しかねますのでご了承ください。
          </p>
        </div>
      </section>
    </>
  );
};

export default LoginForm;
